//** Import Modules */
import { useEffect, useState } from "react";
import ChatBoxContainer from "../../components/chatbox/ChatBoxContainer";
import PageTitle from "../../components/header/PageTitle";
import ContactForm from "../../components/common/ContactForm";

export default function AboutUs() {
  return (
    <div>
      <PageTitle pageTitle="Contact Us" />

      <div className="BIZZLL-video-player">
        <div className="inner-container about-container"></div>
      </div>

      <ContactForm />
    </div>
  );
}
